import React, { Component } from "react";
import styled from "styled-components";
import { RichText } from "prismic-reactjs";
import { media } from "../../../constants/theme";
import { Helmet } from "react-helmet";
import { PageWrapper } from "../../components/page-wrapper";
import { Footer } from "../../components/footer";
import { Inner } from "../../atoms/inner";
import { ExternalLinkButton } from "../../atoms/button";
import { Accordion } from "../../atoms/accordion";
import { fetchResource } from "../../../store/thunks/resources";

const BannerImage = styled.div`
  height: 70vh;
  background: ${(props) =>
    props.isSkillcrush
      ? "linear-gradient( rgba(0,0,0,0), rgba(0,0,0,0.25) ),"
      : null} url('${(props) =>
  props.bannerImg ? props.bannerImg : ""}') center center;  
  background-size: cover;

  ${(props) =>
    props.isSkillcrush
      ? `
    background-position-x: right; 
  `
      : null}

  ${media.tablet`
    background-position-x: center;
  `}

`;

const ContentWrapper = styled.div`
  a {
    color: #2222ca;
  }
`;

const HeroWrapper = styled.div`
  position: relative;
`;

const Logo = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 5px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
  padding: 10px;
  background-color: #fff;
`;

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: -14px;
  left: 20px;
  align-items: center;
  width: calc(100% - 20px);

  ${media.desktop`
    width: 800px;  
    left: 50%;
    transform: translateX(-50%)
  `}
`;

const HeadingInfo = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
  margin-left: 15px;
`;

const ResourceTitle = styled.h1`
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 3px;
  text-align: center;

  ${media.desktop`
    font-size: 24px;
  `}
`;

const Category = styled.p`
  font-size: 16px;
  margin: 0;
  text-transform: capitalize;
`;

const ResourceContent = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;

  p {
    margin-bottom: 10px;
    margin-top: 0;
    font-size: 20px;
  }

  ${media.desktop`
    max-width:830px;
    margin: 40px auto 40px;
  `}
`;

const SecondaryHeading = styled.h2`
  font-size: 20px;
  margin-bottom: 10px;
  margin-top: 40px;
  font-weight: 400;
  display: inline-block;
  width: auto;
  font-weight: 600;
`;

const BottomImages = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Image = styled.img`
  width: 100%;
  &:last-child {
    display: none;
  }
  &:first-child {
    display: none;
  }
  ${media.tablet`
    width: 50%;
    &:first-child {
      display:block;
    }    
  `}
  ${media.desktop`
    width: calc(100% / 3);
    &:last-child {
      display:block;
    }
  `}
`;

const FAQBlock = styled.div`
  margin-bottom: 10px;
  margin-top: 40px;
`;

const getResourceId = (url) => {
  return url.split("/")[3]; // Return the second part of the URL
};

export class Resource extends Component {
  static fetchData(store, url) {
    const resourceId = getResourceId(url);
    return store.dispatch(fetchResource(resourceId));
  }

  shouldComponentUpdate(props) {
    let url = window.location.pathname;
    if (props.uid !== getResourceId(url)) {
      window.scrollTo(0, 0);
      this.props.fetchResource(getResourceId(url));
    }
    return true;
  }

  componentDidMount() {
    let url = window.location.pathname;
    if (this.props.uid !== getResourceId(url)) {
      window.scrollTo(0, 0);
      this.props.fetchResource(getResourceId(url));
    }
  }

  render() {
    const {
      title,
      summary,
      description,
      logo,
      hero_image_desktop,
      footer_image_one,
      footer_image_two,
      footer_image_three,
      review,
      faqs,
      category,
      url,
      social_share_image,
      meta_description,
    } = this.props;

    return (
      <div>
        <Helmet>
          <title>
            {title.length > 0 ? `Discover ${title}` : ""} - JustRemote
          </title>
          <meta
            name="description"
            content={meta_description ? meta_description : ""}
          />
          <meta
            property="og:title"
            content={title.length > 0 ? `Discover ${title}` : ""}
          />
          <meta property="og:type" content="article" />
          <meta property="og:image" content={social_share_image} />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@justremoteco" />
          <meta name="twitter:creator" content="@supert56" />
          <meta
            name="twitter:title"
            content={title.length > 0 ? `Discover ${title}` : ""}
          />
          <meta
            name="twitter:description"
            content={meta_description ? meta_description : ""}
          />
          <meta name="twitter:image" content={social_share_image} />
        </Helmet>
        <PageWrapper>
          <HeroWrapper>
            <BannerImage
              isSkillcrush={title === "Skillcrush" ? true : false}
              bannerImg={hero_image_desktop && hero_image_desktop.url}
              // bannerImg="https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=e521f1ad359392508e578117b584f891&auto=format&fit=crop&w=2550&q=80"
            />
            <HeadingWrapper>
              <Logo src={logo && logo.url} alt={logo && logo.alt} />
              <HeadingInfo>
                <ResourceTitle>{title}</ResourceTitle>
                <Category>{category}</Category>
              </HeadingInfo>
            </HeadingWrapper>
          </HeroWrapper>
          <ResourceContent>
            <Inner>
              <ContentWrapper>
                {summary.length ? RichText.render(summary) : null}
                <SecondaryHeading>Details</SecondaryHeading>
                {description.length ? RichText.render(description) : null}
                {faqs.length > 0 ? (
                  <FAQBlock>
                    {faqs.map((faq, i) => {
                      return (
                        <div key={i}>
                          <Accordion
                            title={faq.faq_title[0].text}
                            description={faq.faq_description}
                            prismicHTML
                          />
                        </div>
                      );
                    })}
                  </FAQBlock>
                ) : null}
                <SecondaryHeading>
                  Why we{" "}
                  <span role="img" aria-label="love">
                    💖
                  </span>{" "}
                  {title}
                </SecondaryHeading>
                {review.length ? RichText.render(review) : null}
              </ContentWrapper>
              <br />
              <ExternalLinkButton
                path={`https://${url}`}
                align="left"
                title={`Visit ${title}`}
              />
            </Inner>
          </ResourceContent>
          <BottomImages>
            <Image src={footer_image_one && footer_image_one.url} />
            <Image src={footer_image_two && footer_image_two.url} />
            <Image src={footer_image_three && footer_image_three.url} />
          </BottomImages>
          <Footer />
          {/* 
          <div>Meta data + Social</div>
          <div>Available Markets (The markets this product is useful in)</div> 
          */}
        </PageWrapper>
      </div>
    );
  }
}
